module.exports = __webpack_public_path__ + "static/media/empty_state_sales.306184d0.png";